import { jsx as e, jsxs as o } from "react/jsx-runtime";

import { useForm as t, FormProvider as r, useFormContext as i } from "react-hook-form";

import { yupResolver as m } from "@hookform/resolvers/yup";

import n from "@ui-components-3/ui/lib/components/Menu";

import s from "@ui-components-3/icons/lib/solid/BarsFilter";

import l from "@ui-components-3/ui/lib/hooks/useId";

import { useState as a, useMemo as u, useCallback as p, useEffect as c } from "react";

import b from "@ui-components-3/ui/lib/utils/classNames";

import { SlotsFiltersSchema as d, PROVIDER_SCHEDULE_SLOTS_FILTERS as f } from "../../../utils.js";

import { useProviderSchedule as h } from "../../../hooks/useProviderSchedule.js";

import x from "../../hook-form/FormCheckbox.js";

const k = Object.keys(f), y = ({id: o, onSubmit: t}) => {
    const {handleSubmit: r} = i();
    return e("form", {
        className: "flex w-[290px] flex-col gap-5 bg-white p-7 pb-5",
        onSubmit: r(t),
        id: o,
        children: k.map((o => e(x, {
            name: o,
            label: f[o]
        }, o)))
    });
}, N = ({currentFilters: i, onApply: f}) => {
    const [x, N] = a(!1), S = l("slotsFilters"), {variantClassNames: g} = h(), j = t({
        resolver: m(d),
        mode: "onSubmit",
        defaultValues: i
    }), {reset: v, watch: C, formState: {isDirty: F}} = j, w = C(k), O = u((() => w.some(Boolean)), [ w ]), A = p((e => {
        f?.(e), N(!1);
    }), [ f ]), B = p((() => {
        N(!1);
    }), []);
    return c((() => {
        x || v(i, {
            keepDirty: !1
        });
    }), [ i, x, v ]), e(r, {
        ...j,
        children: o(n, {
            className: "btn-sm btn-neutral-outlined",
            type: "button",
            items: [],
            opened: x,
            onOpenChange: N,
            prefix: e(y, {
                id: S,
                onSubmit: A
            }),
            suffix: o("div", {
                className: "flex items-center gap-4 bg-white p-3 pt-0",
                children: [ e("button", {
                    type: "button",
                    className: b("btn-md flex-1", g.buttonOutlined),
                    onClick: B,
                    children: "Cancel"
                }), e("button", {
                    type: "submit",
                    form: S,
                    className: b("btn-md flex-1", g.buttonMain),
                    disabled: !O || !F,
                    children: "Apply"
                }) ]
            }),
            children: [ e(s, {
                "aria-hidden": "true"
            }), "Filter" ]
        })
    });
};

export { N as default };
//# sourceMappingURL=SlotsFilters.js.map
